import ClientPortalSetting from "@/store/models/ClientPortalSetting";
import store from "@/store";

let requestingUrl = null;

function reqInt(request) {

    if (request.method === 'options') {
        return request;
    }

    let omittedUrls = [
        '/client/csrf-cookie',
        '/client/login',
        '/client/logout',
        '/client/isAdmin',
        '/client/login-verification',
        'clientPortalSetting',
        'pub/company/portal/loginData'
    ]

    let found = omittedUrls.find((subUrl) => {
        let x = new RegExp(subUrl);
        return request.url.match(x)
    });

    if (found) {
        return request;
    }

    if (requestingUrl) {
        return request;
    }

    requestingUrl = request.url;
    return request;
}

function resInt(response) {
    if (response.method === 'options') {
        return response;
    }

    if ( requestingUrl !== response.config.url) {
        return response;
    }

    let p = Promise.resolve();

    if (store.state.auth.clientPortalSettingSignature == null || store.state.auth.clientPortalSettingSignature !== response.headers['x-portal-setting-sig']){
        p = ClientPortalSetting.getCompanySetting(store.state.auth.user.company_id).then(() => {
            store.commit('auth/setClientPortalSettingSignature', response.headers['x-portal-setting-sig']);
        }).finally(() => {
            requestingUrl = null;
        });
    }

    p.then(() => requestingUrl = null);

    return response;
}

function resetRequestingUrl() {
    requestingUrl = null;
}


export {reqInt, resInt, resetRequestingUrl}
